import _, { filter } from 'lodash';

const locations = (state = [], action) => {

	switch (action.type) {

		case 'SET_LOCATION': {
			let { index, lat, lng, name, type } = action.options;

			// Set precision to 4dp (11m) for URL. If needed 5dp is 1.1m
			lat = lat ? parseFloat(lat).toFixed(5) : lat;
			lng = lng ? parseFloat(lng).toFixed(5) : lng;

			return state.map((location, i) => {

				if (i === index) {

					return lat && lng ? { lat, lng, name, type } : {};

				} else {

					return location
				}
			});
		}

		case 'ADD_LOCATION': {
			let { lat, lng, name, type } = action.options;
			// Set precision to 4dp (11m) for URL. If needed 5dp is 1.1m
			lat = lat ? parseFloat(lat).toFixed(5) : lat;
			lng = lng ? parseFloat(lng).toFixed(5) : lng;

			const locations = [
				...state.filter(location => type === 'waypoint' || (location.type && location.type !== type)),
			 	{ lat, lng, name, type }
			]
			// Ensure locations is 2 items long at min. So that from/to can be set correctly
			return locations.length < 2 ? [...locations, {}] : locations;
		}

		case 'REMOVE_LOCATION': {

			const { index } = action.options;

			return [
				...state.slice(0, index),
				...state.slice(index + 1)
			];
		}

		case 'CLEAR_EMPTY_LOCATIONS': {

			const filtered = _.filter(state, location => location.lat && location.lng);

			const difference = 2 - filtered.length;

			// Keep at least two empty locations (start/end)
			for (var i = 0; i < difference; i++) {
				filtered.push({});
			}

			return filtered;
		}

		case 'SORT_LOCATIONS': {
			
			const { newOrder } = action.options;

			return newOrder;
		}

		case 'CLEAR_ALL_LOCATIONS': {

			return [{}, {}];
		}

		default:
			return state;
	}
}
export default locations;



// WEBPACK FOOTER //
// ./src/reducers/locations.js